import React, { useEffect, useState } from 'react';
import { Card, Col, Empty, Form, Input, List, Modal, Radio, Row, Select, Skeleton, Space, message } from 'antd';
import Cookies from 'js-cookie';
import axios from '../../backendService';
import { Banner1 } from '../banners/Banners';
import BlogCard from '../cards/BlogCard';
import IndividualVideo from '../video-components/IndividualVideo';
import IndividualVideoSkeleton from '../video-components/IndividualVideoSkeleton';
const { Option } = Select;

const ExistingVideosModal = ({
  // courseData,
  userVideos,
  isOpen,
  setOpenVideoModal,
  setPersonalVideoURL,
  setPersonalThumbnailURL,
  setPersonalFileName,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [searchTitle, setSearchTitle] = useState('');
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedChapter, setSelectedChapter] = useState(null);
  const [videosToShow, setVideosToShow] = useState([]);
  const videoPlayerClose = () => {
    setOpenVideoModal(false);
    setSearchTitle('')
    setSelectedCourse(null)
    setSelectedSubject(null)
    setSelectedChapter(null)
  };
  const userId = Cookies.get('userId');

  const [courseData, setCourseData] = useState([]);

  const uniqueVideoURLs = [];
    // === Fetch Courses (Initial Load) ===
    const fetchCourses = async () => {
      try {
        const response = await axios.post('/batch/getByTeacher', { teacherId: userId });
        // console.log('response--------', response);
        if (response.data.success) {
          // message.success('Courses loaded successfully');
          setCourseData(response.data.data);
        } else {
          message.error(response.data.message || 'Failed to load courses.');
        }
      } catch (error) {
        console.error('Error fetching courses:', error);
        message.error('Error fetching courses. Please try again.');
      }
    };
  if (userVideos.length) {
    userVideos.forEach((entry) => {

      // If the videoURL is not in the array, add the complete entry and return true to include this entry
      uniqueVideoURLs.push(entry);
      return true;
    });
  }

  useEffect(() => {
    setVideosToShow(uniqueVideoURLs);
    setSearchTitle('')
    setSelectedCourse(null)
    setSelectedSubject(null)
    setSelectedChapter(null)
  }, [userVideos]);

  useEffect(() => {
    if (selectedCourse) {
      // Fetch subjects for the selected course
      fetchSubjects(selectedCourse);
    }
    if (selectedCourse === undefined) {
      setSelectedSubject(null)
      setSelectedChapter(null)
    }
  }, [selectedCourse]);
  useEffect(() => {
    fetchCourses();
    // form.resetFields();
  }, []);
  // console.log("courseDta",courseData)
  useEffect(() => {
    const filteredVideos = uniqueVideoURLs.filter((item) =>
      item.title.toLowerCase().includes(searchTitle.toLowerCase()) &&
      (selectedCourse ? item.course._id === selectedCourse : true) &&
      (selectedSubject ? item.subject._id === selectedSubject : true) &&
      (selectedChapter ? item.chapter._id === selectedChapter : true)
    );
    setVideosToShow(filteredVideos);
  }, [searchTitle, selectedCourse, selectedSubject, selectedChapter]);

  useEffect(() => {
    if (selectedSubject) {
      // Fetch chapters for the selected subject
      const selectedSubj = subjects.find(sub => sub._id === selectedSubject);
      setChapters(selectedSubj?.chapters || []);
    }
    if (selectedSubject === undefined) {
      setSelectedChapter(null)
    }
  }, [selectedSubject, subjects]);

  const fetchSubjects = async (courseId) => {
    try {
      const userId = Cookies.get('userId');
      const userDetailResponse = await axios.get(`users/userDetail/${userId}`);
      const userDetail = userDetailResponse.data;

      const subjectsResponse = await axios.get(`/topics/courses/${courseId}`);
      let fetchedSubjects = subjectsResponse.data.data;

      if (userDetail.userType === 2) {
        // If userType is 2, filter subjects based on userDetail
        fetchedSubjects = fetchedSubjects.filter(subject => userDetail.subjects.includes(subject._id));
      }
      // Update state with the filtered subjects
      setSubjects(fetchedSubjects);
      setChapters([]);
    } catch (error) {
      console.log("Error fetching subjects:", error);
    }
  };

  const handleCourseChange = (selected) => {
    // console.log("selected ",selected)
    setSelectedCourse(selected);
  };

  const onSubjectSelect = (value) => {
    setSelectedSubject(value);
  };

  const onChapterSelect = (value) => {
    setSelectedChapter(value);
  };

  return (
    <Modal
      open={isOpen}
      title="Select a video"
      okText="Submit"
      cancelText="Cancel"
      onCancel={videoPlayerClose}
      style={{ top: 20 }}
      width={1200}
      footer={null}
    >
      <Row gutter={25}>
        {loading && uniqueVideoURLs.length === 0 ? (
          <>
            <Col xxl={8} xl={12} lg={16} sm={16} xs={24}>
              <IndividualVideoSkeleton />
            </Col>
            <Col xxl={8} xl={12} lg={16} sm={16} xs={24}>
              <IndividualVideoSkeleton />
            </Col>
          </>
        ) : uniqueVideoURLs.length === 0 ? (
          <div className="w-full flex items-center justify-center">
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </div>
        ) : (
          <>
            <Col span={24} className="mb-4">
              <div className='flex justify-center'>
                <div style={{ width: '25%' }}>
                  <Input
                    style={{ width: '100%', padding: '1%', paddingLeft: '3%' }}
                    value={searchTitle}
                    size='small'
                    onChange={(e) => setSearchTitle(e.target.value)}
                    placeholder="Search by Title"
                    allowClear />
                </div>
                <div style={{ width: '25%' }}>
                  <Select
                    style={{ width: '90%', marginLeft: '10%' }}
                    size='small'
                    allowClear
                    // mode="multiple"
                    value={selectedCourse}
                    placeholder="Select Course"
                    onChange={handleCourseChange}
                  >
                    {courseData.map((course) => (
                      <Option key={course.courseId} value={course.courseId}>
                        {course.courseName}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div style={{ width: '25%' }}>
                  <Select
                    style={{ width: '90%', marginLeft: '10%' }}
                    size='small'
                    allowClear
                    placeholder="Select Subject"
                    value={selectedSubject}
                    onChange={onSubjectSelect}
                    disabled={!selectedCourse}>
                    {subjects.map((subject) => (
                      <Option key={subject._id} value={subject._id}>{subject.subjectName}</Option>
                    ))}
                  </Select>
                </div>
                <div style={{ width: '25%' }}>
                  <Select
                    style={{ width: '90%', marginLeft: '10%' }}
                    size='small'
                    allowClear
                    placeholder="Select Chapter"
                    value={selectedChapter}
                    onChange={onChapterSelect}
                    disabled={!selectedSubject}>
                    {chapters.map((chapter) => (
                      <Option key={chapter._id} value={chapter._id}>{chapter.chapterName}</Option>
                    ))}
                  </Select>
                </div>
              </div>
            </Col>
            <div style={{ maxHeight: "50vh", overflowY: 'scroll', width: '100%' }}>
              {videosToShow.length === 0 ? (
                <Col span={22} offset={2}>
                  {/* <div style={{width:'100%'}}> */}
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  {/* </div> */}
                  {/* <p className='text-center'>
                  No questions found for the selected type and difficulty
                </p> */}
                </Col>
              ) : (
                videosToShow.map((video, index) => (
                  <Col key={index} span={24}>
                    <IndividualVideo
                      title={video.title}
                      description={video.description}
                      thumbnailURL={video.thumbnailURL}
                      course={video.course}
                      subject={video.subject}
                      chapter={video.chapter}
                      topic={video.topic}
                      videoURL={video.videoURL}
                      publishDate={video.publishDate ? video.publishDate : ''}
                      startTime={video.startTime ? video.startTime : ''}
                      endTime={video.endTime ? video.endTime : ''}
                      setVideoURL={setPersonalVideoURL}
                      setThumbnailURL={setPersonalThumbnailURL}
                      setFileName={setPersonalFileName}
                      setOpenVideoModal={setOpenVideoModal}
                    />
                  </Col>
                ))
              )
              }
            </div>

          </>
        )}
      </Row>
    </Modal>
  );
};

export default ExistingVideosModal;
